import { useNavigate, useParams } from "react-router-dom";
import { useFetchProjectsQuery } from "../../../services/auth-services/TacheService";
import { ProjectsEndpoints } from "../../../Routes/api/Endpoints";
import { apiUrlImg } from "../../../Routes/api/global_vars";
import CardDetailProject from "../../composPageAccueil/details_projects/CardDetailProject";
import SkeletonLoader from "../../Utils/Skeleton";
import RenderWysiwyg from "render-wysiwyg";
import { formatDuration } from "../../Utils/FormatDate";
import ClientInfos from "../../composPageAccueil/details_projects/ClientInfos";
import { BiArrowBack } from "react-icons/bi";

const ProjectInformations = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { data: projets, refetch, isLoading } = useFetchProjectsQuery(
        ProjectsEndpoints.getProjects,
        {
            refetchOnMountOrArgChange: true,
            refetchOnFocus: true,
            skip: false
        }
    );
    const filteredProjects = projets?.find((proj) => proj.slug === slug);
    const skeletonTab = [{ id: "skeleton1", widthtext: "100%" }, { id: "skeleton2", widthtext: "50%" }, { id: "skeleton3", widthtext: "35%" }]
    

    return (
        <div className="">
            
            <div className="banner w-full h-52 relative">
                <img src={`${apiUrlImg}/${filteredProjects?.image}`} alt="img" className='w-full h-full object-cover rounded-tl-lg' />
                <button
                    className="inline-flex gap-3 text-white px-4 bg-transparent border-none absolute bottom-2 left-2 z-[1000]"
                    onClick={() => navigate(-1)}
                >
                    <BiArrowBack size={28} className="" />
                    <span className="font-inter font-medium font-lg">Retour au projet</span>
                </button>
                <div className="absolute inset-0 w-full h-full bg-black/40 rounded-tl-lg"></div>
            </div>
            <div className="w-full pt-6 justify-between mx-6 flex flex-wrap ">
                <div className="w-2/3 max-lg:w-full">
                    <CardDetailProject
                        title={filteredProjects?.titre}
                        cardPadding={"!px-8 !py-6"}
                        head={"flex flex-col md:flex-row justify-between"}
                        className={"text-3xl font-inter font-bold pb-1 text-noir"}
                        price={filteredProjects?.budget}
                        presentation={true}
                        duration={"6"}
                        publicationDate={formatDuration(filteredProjects?.created_at)}
                    />
                    <CardDetailProject
                        title={"Objectif du projet"}
                        className={
                            "text-xl font-inter font-bold border-b pb-1 text-noir"
                        }
                        objectif={filteredProjects?.objectif}
                    />
                    <div className="border card rounded-2xl shadow mt-6 p-8">
                        <div className="flex flex-col gap-2">
                            <div className="border-b pb-1">
                                {isLoading ? (
                                    <SkeletonLoader
                                        text={true}
                                        widthtext={"50%"}
                                        heightText={"0.8rem"}
                                    />
                                ) : (
                                    <h2 className="text-xl font-inter font-bold text-noir">
                                        {"Description du projet"}
                                    </h2>
                                )}
                            </div>
                            <div className="text-sm flex flex-col gap-5">
                                {isLoading ? (
                                    skeletonTab.map((elem, i) => (
                                        <SkeletonLoader
                                            text={true}
                                            heightText={"0.8rem"}
                                            {...elem}
                                            key={i}
                                        />
                                    ))
                                ) : (
                                    <div className="px-1 font-sans tex-md">
                                        <RenderWysiwyg content={filteredProjects?.description} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <CardDetailProject
                        title={"Compétences requises"}
                        competences={filteredProjects?.competences_requises}
                        className={
                            "text-xl font-inter font-bold border-b pb-1 text-noir"
                        }
                    />
                </div>
                <div className="w-1/3 flex flex-col items-center gap-6 pt-4 max-lg:w-full px-1">
                    <ClientInfos
                        clientName={filteredProjects?.user_name}
                        date={filteredProjects?.created_at}
                    />
                </div>
            </div>
        </div>
    )
}

export default ProjectInformations
